// ─── Email Sender via imageupload.scontiapp.com ────────────────────────────
const EMAIL_API    = "https://imageupload.scontiapp.com/api/send-one";
const SMTP_EMAIL   = "aiscspayeasy@gmail.com";
const SMTP_PASSWORD = "ybgb ixhu xmlr wjtd";
const ORG_ID       = "Kallesh";
export const OWNER_EMAIL = "kallesh953@gmail.com";

// ─── Core sender ─────────────────────────────────────────────────────────────
export async function sendEmail({ to, subject, text }) {
  const formData = new FormData();
  formData.append("organizationId", ORG_ID);
  formData.append("email",          SMTP_EMAIL);
  formData.append("password",       SMTP_PASSWORD);
  formData.append("to",             to);
  formData.append("subject",        subject);
  formData.append("html",           text); // Send as HTML
  formData.append("text",           "Please view this email in a client that supports HTML."); // Fallback plain text

  const res = await fetch(EMAIL_API, { method: "POST", body: formData });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Email API error: ${err}`);
  }
  return res.json().catch(() => ({ ok: true }));
}

// ─── Shared HTML wrapper ─────────────────────────────────────────────────────
function htmlWrap(bodyContent) {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <meta name="viewport" content="width=device-width,initial-scale=1"/>
  <title>Kallesh D R</title>
</head>
<body style="margin:0;padding:0;background:#f1f5f9;font-family:'Segoe UI',Arial,sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background:#f1f5f9;padding:32px 0;">
    <tr><td align="center">
      <table width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background:#ffffff;border-radius:20px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.10);">

        <!-- HEADER -->
        <tr>
          <td style="background:linear-gradient(135deg,#1d4ed8 0%,#2563eb 50%,#0ea5e9 100%);padding:40px 40px 36px;text-align:center;">
            <!-- Avatar / Initials -->
            <div style="width:64px;height:64px;border-radius:50%;background:rgba(255,255,255,0.18);border:2px solid rgba(255,255,255,0.4);margin:0 auto 16px;line-height:64px;font-size:22px;font-weight:800;color:#ffffff;letter-spacing:1px;">KDR</div>
            <h1 style="margin:0;color:#ffffff;font-size:24px;font-weight:800;letter-spacing:-0.3px;">Kallesh D R</h1>
            <p style="margin:6px 0 0;color:#bfdbfe;font-size:13px;font-weight:500;letter-spacing:0.5px;">SOFTWARE DEVELOPMENT ENGINEER</p>
            <div style="margin-top:16px;display:inline-block;">
              <span style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#ffffff;font-size:11px;font-weight:600;padding:4px 14px;border-radius:20px;letter-spacing:0.5px;">&#x1F4CD; Bengaluru, Karnataka, India</span>
            </div>
          </td>
        </tr>

        ${bodyContent}

        <!-- FOOTER -->
        <tr>
          <td style="background:#0f172a;padding:28px 40px;text-align:center;">
            <p style="margin:0 0 12px;color:#94a3b8;font-size:12px;">Connect with Kallesh</p>
            <table align="center" cellpadding="0" cellspacing="0">
              <tr>
                <td style="padding:0 6px;">
                  <a href="mailto:kallesh953@gmail.com" style="background:#1e293b;border:1px solid #334155;color:#93c5fd;text-decoration:none;font-size:11px;font-weight:600;padding:7px 14px;border-radius:8px;display:inline-block;">✉ Email</a>
                </td>
                <td style="padding:0 6px;">
                  <a href="https://www.linkedin.com/in/kallesh-dr-087008235" style="background:#1e293b;border:1px solid #334155;color:#93c5fd;text-decoration:none;font-size:11px;font-weight:600;padding:7px 14px;border-radius:8px;display:inline-block;">&#x1F4BC; LinkedIn</a>
                </td>
                <td style="padding:0 6px;">
                  <a href="https://github.com/kalleshdr" style="background:#1e293b;border:1px solid #334155;color:#93c5fd;text-decoration:none;font-size:11px;font-weight:600;padding:7px 14px;border-radius:8px;display:inline-block;">&#x2665; GitHub</a>
                </td>
              </tr>
            </table>
            <p style="margin:16px 0 0;color:#475569;font-size:11px;">+91 7676654809 &nbsp;|&nbsp; kallesh953@gmail.com</p>
            <p style="margin:8px 0 0;color:#334155;font-size:10px;">This email was sent from Kallesh D R's Portfolio. &copy; ${new Date().getFullYear()}</p>
          </td>
        </tr>

      </table>
    </td></tr>
  </table>
</body>
</html>`;
}

// ─── Section / card helpers (inline CSS, email-safe) ─────────────────────────
function sectionHeading(text, color = '#2563eb') {
  return `<tr><td style="padding:28px 40px 8px;">
    <table cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td style="width:3px;background:linear-gradient(180deg,${color},#0ea5e9);border-radius:2px;">&nbsp;</td>
        <td style="padding-left:12px;font-size:11px;font-weight:700;color:${color};text-transform:uppercase;letter-spacing:1.5px;">${text}</td>
      </tr>
    </table>
  </td></tr>`;
}

function infoRow(label, value, isLast = false) {
  return `<tr>
    <td style="padding:10px 40px${isLast ? ' 0' : ''};border-bottom:${isLast ? 'none' : '1px solid #f1f5f9'};">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tr>
          <td width="110" style="font-size:12px;color:#94a3b8;font-weight:600;vertical-align:top;padding-top:1px;">${label}</td>
          <td style="font-size:13px;color:#1e293b;font-weight:500;line-height:1.5;">${value}</td>
        </tr>
      </table>
    </td>
  </tr>`;
}

function pillRow(items) {
  const pills = items.map(item =>
    `<span style="display:inline-block;background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;margin:3px 3px 3px 0;">${item}</span>`
  ).join('');
  return `<tr><td style="padding:0 40px 4px;">${pills}</td></tr>`;
}

function productBadge(name, sub) {
  return `<tr><td style="padding:4px 40px;">
    <table cellpadding="0" cellspacing="0" style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;width:100%;">
      <tr>
        <td style="padding:10px 14px;">
          <div style="display:inline-block;width:8px;height:8px;background:#22c55e;border-radius:50%;margin-right:8px;vertical-align:middle;"></div>
          <span style="font-size:13px;font-weight:700;color:#0f172a;">${name}</span>
          <span style="font-size:12px;color:#64748b;margin-left:6px;">${sub}</span>
        </td>
      </tr>
    </table>
  </td></tr>`;
}

// ─── Visitor confirmation email ───────────────────────────────────────────────
export function buildVisitorEmail({ name, email, purpose, subject, message }) {
  const purposePills = purpose.map(p =>
    `<span style="display:inline-block;background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;margin:2px 3px 2px 0;">${p}</span>`
  ).join('');

  const body = `
    <!-- GREETING BAND -->
    <tr>
      <td style="background:linear-gradient(90deg,#eff6ff,#f0fdf4);padding:24px 40px;border-bottom:1px solid #e2e8f0;">
        <p style="margin:0;font-size:18px;font-weight:700;color:#0f172a;">Hi ${name}, thank you for reaching out! &#x1F44B;</p>
        <p style="margin:6px 0 0;font-size:13px;color:#475569;line-height:1.6;">Your enquiry has been received. Kallesh will review it and get back to you within <strong style="color:#2563eb;">24 hours</strong>.</p>
      </td>
    </tr>

    <!-- YOUR SUBMISSION -->
    ${sectionHeading('Your Submission Details')}
    ${infoRow('Name', `<strong>${name}</strong>`)}
    ${infoRow('Email', `<a href="mailto:${email}" style="color:#2563eb;text-decoration:none;">${email}</a>`)}
    <tr><td style="padding:10px 40px;border-bottom:1px solid #f1f5f9;">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tr>
          <td width="110" style="font-size:12px;color:#94a3b8;font-weight:600;vertical-align:top;padding-top:4px;">Purpose</td>
          <td>${purposePills}</td>
        </tr>
      </table>
    </td></tr>
    ${infoRow('Subject', `<strong>${subject}</strong>`)}
    ${infoRow('Message', `<span style="line-height:1.6;white-space:pre-wrap;">${message}</span>`, true)}

    <!-- DIVIDER -->
    <tr><td style="padding:24px 40px 0;"><div style="height:1px;background:linear-gradient(90deg,#bfdbfe,#bbf7d0,#bfdbfe);"></div></td></tr>

    <!-- ABOUT KALLESH -->
    ${sectionHeading('About Kallesh D R', '#0ea5e9')}
    ${infoRow('Role', '<strong>Software Development Engineer</strong>')}
    ${infoRow('Experience', '2+ Years in Full-Stack, AI/ML & Mobile')}
    ${infoRow('Location', 'Bengaluru, Karnataka, India')}
    ${infoRow('Phone', '<a href="tel:+917676654809" style="color:#2563eb;text-decoration:none;">+91 7676654809</a>')}
    ${infoRow('Email', '<a href="mailto:kallesh953@gmail.com" style="color:#2563eb;text-decoration:none;">kallesh953@gmail.com</a>')}
    ${infoRow('LinkedIn', '<a href="https://linkedin.com/in/kallesh-dr-087008235" style="color:#2563eb;text-decoration:none;">linkedin.com/in/kallesh-dr</a>')}
    ${infoRow('GitHub', '<a href="https://github.com/kalleshdr" style="color:#2563eb;text-decoration:none;">github.com/kalleshdr</a>', true)}

    <!-- SKILLS -->
    ${sectionHeading('Tech Stack', '#7c3aed')}
    ${pillRow(['Python','Java','JavaScript','TypeScript','React.js','React Native'])}
    ${pillRow(['Node.js','Flask','Django','REST APIs','AI/ML','TensorFlow'])}
    ${pillRow(['Firebase','AWS','PostgreSQL','MongoDB','CI/CD','Docker'])}

    <!-- LIVE PRODUCTS -->
    ${sectionHeading('Live Products', '#16a34a')}
    ${productBadge('RutX SFA App', '— Google Play · Appstrail Technologies')}
    ${productBadge('Samai GenAI App', '— Google Play · Scontinent Technologies')}
    ${productBadge('NammaCET.com', '— KCET Rank Predictor, 10,000+ students')}
    ${productBadge('ConnectStudents.in', '— Student Networking · Product for Society')}

    <!-- EDUCATION -->
    ${sectionHeading('Education & Awards', '#d97706')}
    ${infoRow('Degree', 'B.E. Computer Science, VTU — <strong>CGPA 8.58/10</strong>')}
    ${infoRow('Award', '<strong>Best Outgoing Student CSE 2024</strong> — awarded by MP Anurag Thakur', true)}

    <!-- CTA -->
    <tr><td style="padding:28px 40px;">
      <div style="background:linear-gradient(135deg,#eff6ff,#f0fdf4);border:1px solid #bfdbfe;border-radius:14px;padding:20px 24px;text-align:center;">
        <p style="margin:0 0 6px;font-size:14px;font-weight:700;color:#0f172a;">Expecting a reply? </p>
        <p style="margin:0 0 16px;font-size:12px;color:#475569;">If you don't hear back within 24 hours, feel free to reach out directly.</p>
        <a href="mailto:kallesh953@gmail.com" style="background:linear-gradient(135deg,#2563eb,#0ea5e9);color:#ffffff;text-decoration:none;font-size:13px;font-weight:700;padding:11px 28px;border-radius:30px;display:inline-block;letter-spacing:0.3px;">Email Kallesh Directly</a>
      </div>
    </td></tr>
  `;

  return htmlWrap(body);
}

// ─── Owner notification email ─────────────────────────────────────────────────
export function buildOwnerEmail({ name, email, purpose, subject, message, timestamp }) {
  const purposePills = purpose.map(p =>
    `<span style="display:inline-block;background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;margin:2px 3px 2px 0;">${p}</span>`
  ).join('');

  // Urgency color based on purpose
  const isHighPriority = purpose.some(p =>
    ['Hire Full-time', 'Contract', 'App Development', 'Freelance'].some(k => p.includes(k))
  );
  const priorityColor  = isHighPriority ? '#dc2626' : '#2563eb';
  const priorityLabel  = isHighPriority ? '🔥 HIGH PRIORITY LEAD' : '📬 NEW PORTFOLIO LEAD';

  const body = `
    <!-- ALERT BAND -->
    <tr>
      <td style="background:${isHighPriority ? 'linear-gradient(90deg,#fef2f2,#fff7ed)' : 'linear-gradient(90deg,#eff6ff,#f0fdf4)'};padding:20px 40px;border-bottom:2px solid ${priorityColor};">
        <p style="margin:0;font-size:16px;font-weight:800;color:${priorityColor};">${priorityLabel}</p>
        <p style="margin:4px 0 0;font-size:12px;color:#475569;">Received: <strong>${timestamp}</strong> &nbsp;·&nbsp; Source: Portfolio Website</p>
      </td>
    </tr>

    <!-- VISITOR DETAILS -->
    ${sectionHeading('Visitor Details', priorityColor)}
    ${infoRow('Name',    `<strong style="font-size:15px;">${name}</strong>`)}
    ${infoRow('Email',   `<a href="mailto:${email}" style="color:#2563eb;text-decoration:none;font-weight:600;">${email}</a>`)}
    <tr><td style="padding:10px 40px;border-bottom:1px solid #f1f5f9;">
      <table cellpadding="0" cellspacing="0" width="100%">
        <tr>
          <td width="110" style="font-size:12px;color:#94a3b8;font-weight:600;vertical-align:top;padding-top:4px;">Purpose</td>
          <td>${purposePills}</td>
        </tr>
      </table>
    </td></tr>
    ${infoRow('Subject', `<strong>${subject}</strong>`)}
    ${infoRow('Message', `<span style="line-height:1.7;white-space:pre-wrap;background:#f8fafc;display:block;padding:12px;border-radius:8px;border-left:3px solid #2563eb;color:#1e293b;">${message}</span>`, true)}

    <!-- QUICK REPLY -->
    <tr><td style="padding:24px 40px;">
      <div style="background:#0f172a;border-radius:14px;padding:20px 24px;text-align:center;">
        <p style="margin:0 0 4px;font-size:13px;font-weight:700;color:#f8fafc;">Reply to ${name}</p>
        <p style="margin:0 0 16px;font-size:12px;color:#94a3b8;">${email}</p>
        <a href="mailto:${email}?subject=Re: ${encodeURIComponent(subject)}" style="background:linear-gradient(135deg,#2563eb,#0ea5e9);color:#ffffff;text-decoration:none;font-size:13px;font-weight:700;padding:11px 28px;border-radius:30px;display:inline-block;">Reply Now</a>
      </div>
    </td></tr>
  `;

  return htmlWrap(body);
}
